/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  branch Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_LOSS_REASON(state, loss) {
    state.lossReasons.unshift(loss);
    state.totalDataRow++;
  },
  SET_LOSS_REASONS(state, res) {
    state.lossReasons = res.items
    state.totalDataRow = res.totalCount;
  },
  UPDATE_LOSS_REASON(state, lossReason) {
    const productIndex = state.lossReasons.findIndex((p) => p.id == lossReason.id)
    Object.assign(state.lossReasons[productIndex], lossReason)
  },
  REMOVE_LOSS_REASON(state, lossReasonId) {
    const lossReasonIndex = state.lossReasons.findIndex((p) => p.id == lossReasonId)
    state.lossReasons.splice(lossReasonIndex, 1)
  }
}
